import { render } from "./CloseButton.vue?vue&type=template&id=8f6df088&scoped=true&ts=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=8f6df088&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6df088"]])

export default __exports__